module.exports = __webpack_public_path__ + "static/media/SIMPeeL.73e2339d.png";